import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiRequest from "../../functions/api";
import { Typography, MenuItem, Grid, Box, Button, InputAdornment, Card } from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import TextField from "@mui/material/TextField";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Autocomplete from "@mui/material/Autocomplete";
import { useMessage } from "../../context/message-context";
import { pad } from "../../functions/default";
import { DateTextField } from "../lib";
import { Mitarbeiterauswahl } from "../lib";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { FullPageSpinner } from "../lib";
import { DateToJulian } from "../../functions/dates";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment";

const farbe_fertig = "076, 175, 080";
const farbe_error = "244, 067, 054";

function A1CertificateNew(props) {
  const { t } = useTranslation();
  let { antragid } = useParams();
  const navigate = useNavigate();
  var today = new Date();
  const { accessToken, client, admin } = props;
  const { showErrorMessage, hideMessage } = useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const [vonzeitraum, setVonZeitraum] = useState(
    today.getFullYear() + "-" + pad(today.getMonth() + 1, 2) + "-" + pad(today.getDate(), 2)
  );
  const [geladenvonzeitraum, setGeladenVonZeitraum] = useState("");
  const [biszeitraum, setBisZeitraum] = useState(
    today.getFullYear() + "-" + pad(today.getMonth() + 1, 2) + "-" + pad(today.getDate(), 2)
  );
  const [vertragstatus, setVertragStatus] = useState("");
  const [ueberlassen, setUeberlassen] = useState("");
  const [anschrift, setAnschrift] = useState("");
  const [issending, setIssending] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [strasse, setStrasse] = useState("");
  const [hnr, setHnr] = useState("");
  const [zusatz, setZusatz] = useState("");
  const [plz, setPlz] = useState("");
  const [ort, setOrt] = useState("");
  const [mitarbeiter, setMitarbeiter] = useState("");
  const [anzeigema, setAnzeigeMa] = useState("");
  const [beschaeftstelle, setBeschaeftStelle] = useState("");
  const leere_beschaeftstelle_daten = {
    name: "",
    weitere: "",
    strasse: "",
    hnr: "",
    zusatz: "",
    plz: "",
    ort: "",
    auswahl: "",
    auswahlbez: "",
  };
  const [beschaeftstellendaten, setBeschaeftStellenDaten] = useState([leere_beschaeftstelle_daten]);
  const [abloesen, setAbloesen] = useState("");
  const [ablgeschlecht, setAblGeschlecht] = useState("");
  const [ablvorname, setAblVorname] = useState("");
  const [ablnachname, setAblNachname] = useState("");
  const [ablgeburtsdatum, setAblGeburtsdatum] = useState("");
  const [ablgrund, setAblGrund] = useState("");
  const [ablgeplantbeginn, setAblGeplantBeginn] = useState("");
  const [ablgeplantende, setAblGeplantEnde] = useState("");
  const [abltatsachbeginn, setAblTatSachBeginn] = useState("");
  const [abltatsachende, setAblTatSachEnde] = useState("");
  const [weiterbeschaeft, setWeiterBeschaeft] = useState("");
  const leere_weitere_beschaeft_daten = { von: "", bis: "", weitere: "" };
  const [weiterbeschaeftdaten, setWeiterBeschaeftDaten] = useState([leere_weitere_beschaeft_daten]);
  const [interviewdaten, setInterviewDaten] = useState("");
  const [firmendetailsrechtsform, setFirmenDetailsRechtsform] = useState("");
  const [firmendetailssektor, setFirmenDetailsSektor] = useState("");
  const [firmendetailsumsatzgr25, setFirmenDetailsUmsatzGr25] = useState("");
  const [firmendetailsarbeiter25, setFirmenDetailsArbeiter25] = useState("");
  const [firmendetailsanspruch, setFirmenDetailsAnspruch] = useState("");
  const [firmendetailsanwerbung, setFirmenDetailsAnwerbung] = useState("");
  const [firmendetailsarbeitsvertrag, setFirmenDetailsArbeitsvertrag] = useState("");
  const [firmendetailsentlassung, setFirmenDetailsEntlassung] = useState("");
  const [firmendetailsaufgaben, setFirmenDetailsAufgaben] = useState("");
  const [firmendetailskontakt, setFirmenDetailsKontakt] = useState("");
  const [firmenkontaktvorname, setFirmenKontaktVorname] = useState("");
  const [firmenkontaktnachname, setFirmenKontaktNachname] = useState("");
  const [firmenkontaktgeschlecht, setFirmenKontaktGeschlecht] = useState("");
  const [firmenkontaktmail, setFirmenKontaktMail] = useState("");
  const [firmenkontakttelefon, setFirmenKontaktTelefon] = useState("");
  const [errmail, setErrMail] = useState("");
  const [tatsaechlicheinformationen, setTatsaechlicheInformationen] = useState("");
  const [kontakte, setKontakte] = useState({});
  const [laender, setLaender] = useState([]);
  const [land, setLand] = useState(null);
  const [taetigkeiten, setTaetigkeiten] = useState([]);
  const [taetigkeit, setTaetigkeit] = useState("");
  const [kontaktlock, setKontaktLock] = useState(false);
  const [zeitraumfehler, setZeitraumFehler] = useState("");
  const [taetfehler, setTaetFehler] = useState("");
  const [ortfehler, setOrtFehler] = useState("");
  const [strfehler, setStrFehler] = useState("");
  const [plzfehler, setPlzFehler] = useState("");
  const [hnrfehler, sethnrFehler] = useState("");
  const [kontaktnamefehler, setKontaktNameFehler] = useState("");
  const [kontaktvornamefehler, setKontaktVorameFehler] = useState("");
  const [ablnamefehler, setAblNameFehler] = useState("");
  const [ablvornamefehler, setAblVorameFehler] = useState("");
  const [ladedaten, setLadeDaten] = useState(false);
  const [geladenebeschaeft, setGeladeneBeschaeft] = useState([]);
  const [ausgewaehltestellen, setAusgewaehlteStellen] = useState([""]);
  const [festeauslandsstellen, setFesteAuslandsStellen] = useState([]);
  const [schiffname, setSchiffName] = useState("");
  const [schiffimo, setSchiffIMO] = useState("");
  const [stornoGrund, setStornoGrund] = useState("");
  const [versandNummer, setVersandNummer] = useState("");
  const [antragStatus, setAntragStatus] = useState("");

  const daten_speichern = () => {
    setIsProcessing(true);
    const payload = {
      mandant: client,
      program: "LA1MAP",
      start: admin ? "" : "INIT_AN",
      statement: "SPEICHERE_ANTRAG",
      von: vonzeitraum,
      bis: biszeitraum,
      land: land,
      taetigkeit: taetigkeit,
      vertragstatus: vertragstatus,
      ueberlassen: ueberlassen,
      anschrift: anschrift,
      anschrift_strasse: strasse,
      anschrift_hnr: hnr,
      anschrift_zusatz: zusatz,
      anschrift_plz: plz,
      anschrift_ort: ort,
      beschaftstelle: beschaeftstelle,
      beschaftstellendaten: beschaeftstellendaten,
      abloesen: abloesen,
      abloesen_geschlecht: ablgeschlecht,
      abloesen_vorname: ablvorname,
      abloesen_nachname: ablnachname,
      abloesen_geburtsdatum: ablgeburtsdatum,
      abloesen_grund: ablgrund,
      abloesen_geplant_beginn: ablgeplantbeginn,
      abloesen_geplant_ende: ablgeplantende,
      abloesen_tatsaechlich_beginn: abltatsachbeginn,
      abloesen_tatsaechlich_ende: abltatsachende,
      weitere_beschaeftigung: weiterbeschaeft,
      weitere_beschaeftigungdaten: weiterbeschaeftdaten,
      firmendetails_rechtsform: firmendetailsrechtsform,
      firmendetails_sektor: firmendetailssektor,
      firmendetails_umsatz_25: firmendetailsumsatzgr25,
      firmendetails_an_25: firmendetailsarbeiter25,
      firmendetails_anspruch: firmendetailsanspruch,
      firmendetails_anwerbung: firmendetailsanwerbung,
      firmendetails_arbeitsvertrag: firmendetailsarbeitsvertrag,
      firmendetails_entlassung: firmendetailsentlassung,
      firmendetails_aufgaben: firmendetailsaufgaben,
      firmendetails_kontakt: firmendetailskontakt,
      firmendetails_kontakt_vorname: firmenkontaktvorname,
      firmendetails_kontakt_nachname: firmenkontaktnachname,
      firmendetails_kontakt_geschlecht: firmenkontaktgeschlecht,
      firmendetails_kontakt_mail: firmenkontaktmail,
      firmendetails_kontakt_telefon: firmenkontakttelefon,
      schiff_name: schiffname,
      schiff_imo: schiffimo,
      mitarbeiter: mitarbeiter,
      antragid: antragid,
      grund: stornoGrund,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, speichercb, errorCb);
  };
  const speichercb = (response) => {
    setIsProcessing(false);
    if (response.status === 200) {
      if (response.data.message === "OK") {
        navigate(-1);
      } else {
        showErrorMessage(response.data.message);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
        if (response.data.zeitraum) {
          setZeitraumFehler(response.data.zeitraum);
        }
        if (response.data.taetfehler) {
          setTaetFehler(response.data.taetfehler);
        }
        if (response.data.ortfehler) {
          setOrtFehler(response.data.ortfehler);
        }
        if (response.data.strfehler) {
          setStrFehler(response.data.strfehler);
        }
        if (response.data.hnrfehler) {
          sethnrFehler(response.data.hnrfehler);
        }
        if (response.data.plzfehler) {
          setPlzFehler(response.data.plzfehler);
        }
        if (response.data.kontaktnamefehler) {
          setKontaktNameFehler(response.data.kontaktnamefehler);
        }
        if (response.data.kontaktvornamefehler) {
          setKontaktVorameFehler(response.data.kontaktvornamefehler);
        }
        if (response.data.ablnamefehler) {
          setAblNameFehler(response.data.ablnamefehler);
        }
        if (response.data.ablvornamefehler) {
          setAblVorameFehler(response.data.ablvornamefehler);
        }
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  useEffect(() => {
    if (antragid || mitarbeiter || !admin) {
      setIsLoading(true);
      const payload = {
        mandant: client,
        program: "LA1MAP",
        start: admin ? "" : "INIT_AN",
        statement: "LESE_INTERVIEW_DATEN",
        mitarbeiter: mitarbeiter,
        antragid: antragid,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, datenCb, errorCb);
    }
    // eslint-disable-next-line
  }, [mitarbeiter]);
  useEffect(() => {
    if (land) {
      setAusgewaehlteStellen([""]);
      setBeschaeftStellenDaten([leere_beschaeftstelle_daten]);
      setLadeDaten(true);
      const payload = {
        mandant: client,
        program: "LA1MAP",
        start: admin ? "" : "INIT_AN",
        statement: "LESE_ALT_ENTSENDUNG",
        mitarbeiter: mitarbeiter,
        antragid: antragid,
        land: land,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, entsendungCb, errorCb);
    }
    // eslint-disable-next-line
  }, [land]);
  useEffect(() => {
    if (vonzeitraum !== geladenvonzeitraum) {
      var temp_daten = [];
      var pruef_von = vonzeitraum;
      var tage = 0;
      if (geladenebeschaeft.length > 0) {
        geladenebeschaeft?.map((element) => {
          tage = DateToJulian(new Date(element.von_anzeige)) - DateToJulian(new Date(pruef_von));
          if (tage < 0 && tage > -62) {
            temp_daten.push({
              von: element.von_anzeige,
              bis: element.bis_anzeige,
              weitere: "J",
            });
            pruef_von = element.von_anzeige;
          }
          return temp_daten;
        });
        if (temp_daten.length > 0) {
          temp_daten[temp_daten.length - 1].weitere = "";
          setWeiterBeschaeftDaten(temp_daten);
          setWeiterBeschaeft("J");
        }
      }
    }
    // eslint-disable-next-line
  }, [vonzeitraum, geladenebeschaeft]);
  const errorCb = () => {
    setIsLoading(false);
    setLadeDaten(false);
    setIsProcessing(false);
    showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
  };
  const pruefe_mail = (value) => {
    setFirmenKontaktMail(value);
    if (value === "") {
      setErrMail("Bitte geben Sie eine gültige E-Mailadresse ein");
    } else {
      if (!value.includes("@") || !value.includes(".")) {
        setErrMail("Bitte geben Sie eine gültige E-Mailadresse ein");
      } else {
        setErrMail("");
      }
    }
  };
  const entsendungCb = (response) => {
    setLadeDaten(false);
    if (response.status === 200) {
      if (response.data.beschaeft) {
        setGeladeneBeschaeft(response.data.beschaeft);
      }
      if (response.data.stellen) {
        setFesteAuslandsStellen(response.data.stellen);
        if (response.data.stellen.length < 2) {
          setAusgewaehlteStellen(["0"]);
        }
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      }
    }
  };
  const datenCb = (response) => {
    if (response.status === 200) {
      setInterviewDaten(response.data);
      setLaender(response.data.land);
      setFirmenDetailsRechtsform(response.data.rechtsform);
      setFirmenDetailsSektor(response.data.sektor);
      setFirmenDetailsUmsatzGr25(response.data.umsatz_gr_25);
      setFirmenDetailsArbeiter25(response.data.an_25);
      setFirmenDetailsAnspruch(response.data.anspruch);
      setFirmenDetailsAnwerbung(response.data.anwerbung);
      setFirmenDetailsArbeitsvertrag(response.data.arbeitsvertrag);
      setFirmenDetailsEntlassung(response.data.entlassung);
      setFirmenDetailsAufgaben(response.data.aufgaben);
      if (response.data.taet) {
        setTaetigkeiten(response.data.taet);
        setTaetigkeit(response.data.taetigkeit_key);
      }
      if (response.data.versandnr) {
        setVersandNummer(response.data.versandnr);
      }
      if (response.data.antrag_status) {
        setAntragStatus(response.data.antrag_status);
      }
      if (response.data.kontakt) {
        setKontakte(response.data.kontakt);
      }
      if (response.data.autokontakt) {
        setFirmenDetailsKontakt(response.data.autokontakt);
        setKontaktLock(true);
      }
      if (response.data.ma_anzeige) {
        setAnzeigeMa(response.data.ma_anzeige);
      }
      if (response.data.mitarbeiter) {
        setMitarbeiter(response.data.mitarbeiter);
      }
      if (response.data.la1m_land) {
        setLand(response.data.la1m_land);
      }
      if (response.data.la1m_von) {
        setVonZeitraum(response.data.la1m_von);
        setGeladenVonZeitraum(response.data.la1m_von);
      }
      if (response.data.la1m_bis) {
        setBisZeitraum(response.data.la1m_bis);
      }
      if (response.data.la1m_vertragsstatus) {
        setVertragStatus(response.data.la1m_vertragsstatus);
      }
      if (response.data.la1m_ueberlassung) {
        setUeberlassen(response.data.la1m_ueberlassung);
      }
      if (response.data.la1m_firmen_vorhanden) {
        setAnschrift(response.data.la1m_firmen_vorhanden);
      }
      if (response.data.la1m_firmen_str) {
        setStrasse(response.data.la1m_firmen_str);
      }
      if (response.data.la1m_firmen_ort) {
        setOrt(response.data.la1m_firmen_ort);
      }
      if (response.data.la1m_firmen_plz) {
        setPlz(response.data.la1m_firmen_plz);
      }
      if (response.data.la1m_firmen_hnr) {
        setHnr(response.data.la1m_firmen_hnr);
      }
      if (response.data.la1m_firmen_adrzus) {
        setZusatz(response.data.la1m_firmen_adrzus);
      }
      if (response.data.la1m_beschaeft_stelle) {
        setBeschaeftStelle(response.data.la1m_beschaeft_stelle);
      }
      if (response.data.stellen) {
        setBeschaeftStellenDaten(response.data.stellen);
      }
      if (response.data.la1m_abloesen) {
        setAbloesen(response.data.la1m_abloesen);
      }
      if (response.data.la1m_abloesen_name) {
        setAblNachname(response.data.la1m_abloesen_name);
      }
      if (response.data.la1m_abloesen_vorname) {
        setAblVorname(response.data.la1m_abloesen_vorname);
      }
      if (response.data.la1m_abloesen_geschlecht) {
        setAblGeschlecht(response.data.la1m_abloesen_geschlecht);
      }
      if (response.data.la1m_abloesen_grund) {
        setAblGrund(response.data.la1m_abloesen_grund);
      }
      if (response.data.la1m_abloesen_gebdat) {
        setAblGeburtsdatum(response.data.la1m_abloesen_gebdat);
      }
      if (response.data.la1m_abloesen_geplant_vondat) {
        setAblGeplantBeginn(response.data.la1m_abloesen_geplant_vondat);
      }
      if (response.data.la1m_abloesen_geplant_bisdat) {
        setAblGeplantEnde(response.data.la1m_abloesen_geplant_bisdat);
      }
      if (response.data.la1m_abloesen_vondat) {
        setAblTatSachBeginn(response.data.la1m_abloesen_vondat);
      }
      if (response.data.la1m_abloesen_bisdat) {
        setAblTatSachEnde(response.data.la1m_abloesen_bisdat);
      }
      if (response.data.la1m_weitere_beschaeft) {
        setWeiterBeschaeft(response.data.la1m_weitere_beschaeft);
      }
      if (response.data.weitere) {
        setWeiterBeschaeftDaten(response.data.weitere);
      }
      if (response.data.kontakt_geschlecht) {
        setFirmenKontaktGeschlecht(response.data.kontakt_geschlecht);
      }
      if (response.data.kontakt_nachname) {
        setFirmenKontaktNachname(response.data.kontakt_nachname);
      }
      if (response.data.kontakt_vorname) {
        setFirmenKontaktVorname(response.data.kontakt_vorname);
      }
      if (response.data.kontakt_mail) {
        setFirmenKontaktMail(response.data.kontakt_mail);
      }
      if (response.data.kontakt_telefon) {
        setFirmenKontaktTelefon(response.data.kontakt_telefon);
      }
      if (response.data.antragsstellen) {
        setAusgewaehlteStellen(response.data.antragsstellen);
      }
      if (response.data.la1m_schiff_name) {
        setSchiffName(response.data.la1m_schiff_name);
      }
      if (response.data.la1m_schiff_imo) {
        setSchiffIMO(response.data.la1m_schiff_imo);
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const vor_dem_senden = () => {
    if (firmendetailskontakt !== "manuell" || (firmenkontakttelefon !== "" && !errmail)) {
      return (
        <Fragment>
          <Grid item xs={12}>
            <Card>
              <Grid container>
                <Grid xs={12} item>
                  <Box p={1}>
                    <Typography variant="body2">
                      {t(
                        "Mit der Antragstellung erklärt der Arbeitgeber ausdrücklich, dass alle Angaben den tatsächlichen Verhältnissen entsprechen."
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid xs={12} item>
                  <Box p={1}>
                    <Typography variant="body2">
                      {t(
                        "Darüber hinaus verpflichtet er sich, die für den jeweiligen Antrag zuständige Stelle umgehend zu informieren, wenn Änderungen in den Verhältnissen bzw. zu den gemachten Angaben eintreten."
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid xs={12} item>
                  <Box p={1}>
                    <Typography variant="body2">
                      {t(
                        "Soweit z.B. im Zuge einer Kontrolle in einem Mitgliedstaat festgestellt wird, dass - auch irrtümlich - falsche Angaben gemacht oder Änderungen nicht umgehend mitgeteilt wurden, kann dies - ggf. auch rückwirkend - zu einem Widerruf der Bescheinigung A1 und damit zur Anwendung der Rechtsvorschriften des Mitgliedstaats in dem die Beschäftigung tatsächlich ausgeübt wird bzw. wurde, führen."
                      )}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid xs={12} item>
            <Box p={1} pb={0}>
              <Typography variant="body1">
                {t(
                  "Hiermit bestätigen Sie die Richtigkeit der gemachten Angaben, sowie Ihr Einverständnis zu den oben genannten Angaben und Informationen."
                )}
              </Typography>
            </Box>
          </Grid>
          <Grid xs={12} item>
            <Box p={1} pt={0}>
              <JaNeinSelect
                value={tatsaechlicheinformationen}
                onChange={(event) => setTatsaechlicheInformationen(event.target.value)}
                error={tatsaechlicheinformationen === "" || tatsaechlicheinformationen === "N"}
              />
            </Box>
          </Grid>
          {antragid && versandNummer !== "000000" && antragStatus !== "X" && (
            <Grid xs={12} item>
              <Box p={1} pt={0}>
                <A1TextField
                  select
                  label={t("Aus welchem Grund wird der Antrag korrigiert?")}
                  value={stornoGrund}
                  onChange={(event) => setStornoGrund(event.target.value)}
                  error={stornoGrund === ""}
                >
                  <A1MenuItem key="1" value="1">
                    {t("Zeitraum verkürzt sich: beschäftigte Person arbeitet nicht mehr im Ausland.")}
                  </A1MenuItem>
                  <A1MenuItem key="3" value="3">
                    {t(
                      "Zeitraum verkürzt sich: beschäftigte Person ist nicht mehr bei diesem Arbeitgeber beschäftigt."
                    )}
                  </A1MenuItem>
                  <A1MenuItem key="6" value="6">
                    {t("Die übermittelten Angaben waren fehlerhaft.")}
                  </A1MenuItem>
                  <A1MenuItem key="7" value="7">
                    {t("Die beschäftigte Person hat ihren Lebensmittelpunkt nicht länger in Deutschland.")}
                  </A1MenuItem>
                  <A1MenuItem key="8" value="8">
                    {t("Aufnahme zusätzlicher Erwerbstätigkeit/en: ursprünglicher Sachverhalt liegt nicht mehr vor.")}
                  </A1MenuItem>
                </A1TextField>
              </Box>
            </Grid>
          )}
          {tatsaechlicheinformationen === "J" && (stornoGrund !== "" || antragid === undefined) && (
            <Grid item xs={12}>
              <Box p={1}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => daten_speichern()}
                  startIcon={<PostAddIcon />}
                >
                  {t("A1-Bescheinigung erstellen")}
                </Button>
              </Box>
            </Grid>
          )}
        </Fragment>
      );
    }
  };
  const firmenkontakt = () => {
    if (firmendetailskontakt === "manuell") {
      return (
        <Fragment>
          <Grid item xs={12}>
            <Box p={1}>
              <A1TextField
                disabled={kontaktlock && !admin}
                label={t("Vorname")}
                value={firmenkontaktvorname}
                onChange={(event) => setFirmenKontaktVorname(event.target.value)}
                inputProps={{
                  maxLength: 30,
                }}
                error={firmenkontaktvorname === "" || kontaktvornamefehler !== ""}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box p={1}>
              <A1TextField
                label={t("Familienname")}
                disabled={kontaktlock && !admin}
                value={firmenkontaktnachname}
                onChange={(event) => setFirmenKontaktNachname(event.target.value)}
                inputProps={{
                  maxLength: 30,
                }}
                error={firmenkontaktnachname === "" || kontaktnamefehler !== ""}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box p={1}>
              <A1TextField
                select
                label={t("Geschlecht")}
                disabled={kontaktlock && !admin}
                value={firmenkontaktgeschlecht}
                onChange={(event) => setFirmenKontaktGeschlecht(event.target.value)}
                error={firmenkontaktgeschlecht === ""}
              >
                <A1MenuItem key="M" value="M">
                  {t("männlich")}
                </A1MenuItem>
                <A1MenuItem key="W" value="W">
                  {t("weiblich")}
                </A1MenuItem>
                <A1MenuItem key="D" value="D">
                  {t("divers")}
                </A1MenuItem>
                <A1MenuItem key="X" value="X">
                  {t("unbestimmt")}
                </A1MenuItem>
              </A1TextField>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box p={1}>
              <A1TextField
                label={t("Mailadresse")}
                disabled={kontaktlock && !admin}
                value={firmenkontaktmail}
                onChange={(event) => pruefe_mail(event.target.value)}
                error={errmail || firmenkontaktmail === ""}
                helperText={!errmail ? " " : errmail}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box p={1}>
              <A1TextField
                label={t("Telefonnummer")}
                disabled={kontaktlock && !admin}
                value={firmenkontakttelefon}
                onChange={(event) => setFirmenKontaktTelefon(event.target.value)}
                error={firmenkontakttelefon === ""}
              />
            </Box>
          </Grid>
          {vor_dem_senden()}
        </Fragment>
      );
    } else {
      return <Fragment>{vor_dem_senden()}</Fragment>;
    }
  };
  const firmendetails = () => {
    return (
      <Fragment>
        <Grid item xs={12}>
          <A1TextField
            select
            label={t("Welche Rechtsform hat Ihr Unternehmen?")}
            value={firmendetailsrechtsform}
            onChange={(event) => setFirmenDetailsRechtsform(event.target.value)}
            disabled={interviewdaten.rechtsform && !admin}
            error={firmendetailsrechtsform === ""}
          >
            <A1MenuItem key="1" value="1">
              {t("Person oder Kapitalgesellschaft (z.B. AG, OHG, GmbH, etc.)")}
            </A1MenuItem>
            <A1MenuItem key="2" value="2">
              {t("Öffentlicher Arbeitgeber (z.B. Bund, Land, Gemeinde, etc.)")}
            </A1MenuItem>
            <A1MenuItem key="3" value="3">
              {t("Sonstiges (z.B. eingetragener Verein)")}
            </A1MenuItem>
          </A1TextField>
        </Grid>
        <Grid item xs={12}>
          <A1TextField
            select
            label={t("In welchem Wirtschaftssektor ist Ihr Unternehmen tätig?")}
            value={firmendetailssektor}
            onChange={(event) => setFirmenDetailsSektor(event.target.value)}
            disabled={interviewdaten.sektor && !admin}
            error={firmendetailssektor === ""}
          >
            <A1MenuItem key="06" value="06">
              {t("Baugewerbe")}
            </A1MenuItem>
            <A1MenuItem key="02" value="02">
              {t("Bergbau und Gewinnung von Steinen und Erden")}
            </A1MenuItem>
            <A1MenuItem key="04" value="04">
              {t("Energieversorgung")}
            </A1MenuItem>
            <A1MenuItem key="12" value="12">
              {t("Erbringung von Finanz- und Versicherungsdienstleistungen")}
            </A1MenuItem>
            <A1MenuItem key="14" value="14">
              {t("Erbringung von freiberuflichen, wissenschaftlichen oder technischen Dienstleistungen")}
            </A1MenuItem>
            <A1MenuItem key="21" value="21">
              {t("Erbringung von sonstigen Dienstleistungen")}
            </A1MenuItem>
            <A1MenuItem key="15" value="15">
              {t(
                "Erbringung von sonstigen wirtschaftlichen Dienstleistungen (außer Vermittlung und Überlassung von Arbeitskräften)"
              )}
            </A1MenuItem>
            <A1MenuItem key="18" value="18">
              {t("Erziehung und Unterricht")}
            </A1MenuItem>
            <A1MenuItem key="10" value="10">
              {t("Gestgewerbe / Beherbergung und Gastronomie")}
            </A1MenuItem>
            <A1MenuItem key="19" value="19">
              {t("Gesundheits- und Sozialwesen")}
            </A1MenuItem>
            <A1MenuItem key="07" value="07">
              {t("Groß- und Einzelhandel")}
            </A1MenuItem>
            <A1MenuItem key="13" value="13">
              {t("Grundstücks- und Wohnungswesen")}
            </A1MenuItem>
            <A1MenuItem key="11" value="11">
              {t("Information und Kommunikation")}
            </A1MenuItem>
            <A1MenuItem key="20" value="20">
              {t("Kunst, Unterhaltung und Erholung")}
            </A1MenuItem>
            <A1MenuItem key="01" value="01">
              {t("Land- und Forstwirtschaft, Fischerei")}
            </A1MenuItem>
            <A1MenuItem value="17">{t("Öffentliche Verwaltung, Verteidigung, Sozialversicherung")}</A1MenuItem>
            <A1MenuItem key="22" value="22">
              {t("Private Haushalte")}
            </A1MenuItem>
            <A1MenuItem key="03" value="03">
              {t("Verarbeitendes Gewerbe")}
            </A1MenuItem>
            <A1MenuItem key="08" value="08">
              {t("Verkehr (außer Güterbeförderung im Straßenverkehr) und Lagerei")}
            </A1MenuItem>
            <A1MenuItem key="09" value="09">
              {t("Verkehr (Güterbeförderung im Straßenverkehr)")}
            </A1MenuItem>
            <A1MenuItem key="16" value="16">
              {t("Vermittlung und Überlassung von Arbeitskräften")}
            </A1MenuItem>
            <A1MenuItem key="05" value="05">
              {t("Wasserversorgung, Abwasser und Abfallentsorgung, Beseitigung von Umweltverschmutzungen")}
            </A1MenuItem>
          </A1TextField>
        </Grid>
        <Grid item xs={12}>
          <JaNeinSelect
            label={t("Erwirtschaftet Ihr Unternehmen mehr als 25% seines Umsatzes in Deutschland")}
            value={firmendetailsumsatzgr25}
            onChange={(event) => setFirmenDetailsUmsatzGr25(event.target.value)}
            disabled={interviewdaten.umsatz_gr_25 && !admin}
            error={firmendetailsumsatzgr25 === ""}
          />
        </Grid>
        <Grid item xs={12}>
          <JaNeinSelect
            label={t("Beschäftigt Ihr Unternehmen mehr als 25% der Arbeitnehmer in Deutschland?")}
            value={firmendetailsarbeiter25}
            onChange={(event) => setFirmenDetailsArbeiter25(event.target.value)}
            disabled={interviewdaten.an_25 && !admin}
            error={firmendetailsarbeiter25 === ""}
          />
        </Grid>
        <Grid item xs={12}>
          <JaNeinSelect
            label={t("Richtet sich der Entgeltanspruch des Arbeitnehmers weiterhin gegen Ihr Unternehmen?")}
            value={firmendetailsanspruch}
            onChange={(event) => setFirmenDetailsAnspruch(event.target.value)}
            disabled={interviewdaten.anspruch && !admin}
            error={firmendetailsanspruch === ""}
          />
        </Grid>
        <Grid item xs={12}>
          <JaNeinSelect
            label={t("Entscheidet ausschließlich Ihr Unternehmen über die Anwerbung des Arbeitnehmers?")}
            value={firmendetailsanwerbung}
            onChange={(event) => setFirmenDetailsAnwerbung(event.target.value)}
            disabled={interviewdaten.anwerbung && !admin}
            error={firmendetailsanwerbung === ""}
          />
        </Grid>
        <Grid item xs={12}>
          <JaNeinSelect
            label={t("Entscheidet ausschließlich Ihr Unternehmen über den Arbeitsvertrag des Arbeitnehmers?")}
            value={firmendetailsarbeitsvertrag}
            onChange={(event) => setFirmenDetailsArbeitsvertrag(event.target.value)}
            disabled={interviewdaten.arbeitsvertrag && !admin}
            error={firmendetailsarbeitsvertrag === ""}
          />
        </Grid>
        <Grid item xs={12}>
          <JaNeinSelect
            label={t("Entscheidet ausschließlich Ihr Unternehmen über eine Entlassung des Arbeitnehmers?")}
            value={firmendetailsentlassung}
            onChange={(event) => setFirmenDetailsEntlassung(event.target.value)}
            disabled={interviewdaten.entlassung && !admin}
            error={firmendetailsentlassung === ""}
          />
        </Grid>
        <Grid item xs={12}>
          <JaNeinSelect
            label={t(
              "Entscheidet ausschließlich Ihr Unternehmen über die wesentlichen Aufgaben des Arbeitnehmers, während des Auslandsaufenthalts?"
            )}
            value={firmendetailsaufgaben}
            onChange={(event) => setFirmenDetailsAufgaben(event.target.value)}
            disabled={interviewdaten.aufgaben && !admin}
            error={firmendetailsaufgaben === ""}
          />
        </Grid>
        <Grid item xs={12}>
          <A1TextField
            select
            disabled={kontaktlock && !admin}
            label={t("Wer ist die Zuständige Kontaktperson beim Arbeitnehmer?")}
            value={firmendetailskontakt}
            onChange={(event) => setFirmenDetailsKontakt(event.target.value)}
            error={firmendetailskontakt === ""}
          >
       
            {kontakte.length>0 && kontakte?.map((kontakt) => {
              return (
                <A1MenuItem key={kontakt.key} value={kontakt.key}>
                  {kontakt.bezeichnung}
                </A1MenuItem>
              );
            })}
          </A1TextField>
        </Grid>
        {firmenkontakt()}
      </Fragment>
    );
  };
  const edit_weiterbeschaeftdaten = (key, value, id) => {
    var temp_daten = weiterbeschaeftdaten.slice();
    temp_daten[key][id] = value;
    if (id === "weitere") {
      if (value === "J") {
        temp_daten.push(leere_weitere_beschaeft_daten);
      } else {
        temp_daten = temp_daten.slice(0, key + 1);
      }
    }
    setWeiterBeschaeftDaten(temp_daten);
  };
  const weiterbeschaeftdaten_zeichnen = weiterbeschaeftdaten?.map((element, count) => {
    return (
      <Fragment>
        <Grid item xs={12}>
          <A1DateTextField
            label={"Wann begann der " + Number(count + 1) + ". Auslandeinsatz?"}
            value={weiterbeschaeftdaten[count].von}
            onChange={(value) => edit_weiterbeschaeftdaten(count, value, "von")}
            error={weiterbeschaeftdaten[count].von === ""}
          />
        </Grid>
        <Grid item xs={12}>
          <A1DateTextField
            label={"Wann endete der " + Number(count + 1) + ". Auslandeinsatz?"}
            value={weiterbeschaeftdaten[count].bis}
            onChange={(value) => edit_weiterbeschaeftdaten(count, value, "bis")}
            error={weiterbeschaeftdaten[count].bis === ""}
          />
        </Grid>
        {count !== 4 && (
          <Grid item xs={12}>
            <Box p={1}>
              <JaNeinSelect
                label={t("Weitere")}
                value={weiterbeschaeftdaten[count].weitere}
                onChange={(event) => edit_weiterbeschaeftdaten(count, event.target.value, "weitere")}
                error={weiterbeschaeftdaten[count].weitere === ""}
              />
            </Box>
          </Grid>
        )}
      </Fragment>
    );
  });
  const weiterebeschaft = () => {
    return (
      <Fragment>
        <Grid item xs={12}>
          <JaNeinSelect
            label={t("Hat der Arbeitnehmer bereits  in den letzten 2 Monaten im Beschäftigungsstaat gearbeitet?")}
            value={weiterbeschaeft}
            onChange={(event) => setWeiterBeschaeft(event.target.value)}
            error={weiterbeschaeft === ""}
          />
        </Grid>
        {weiterbeschaeft === "J" && weiterbeschaeftdaten_zeichnen}
        {(weiterbeschaeft === "N" ||
          weiterbeschaeftdaten[weiterbeschaeftdaten.length - 1].weitere === "N" ||
          weiterbeschaeftdaten.length === 5) &&
          firmendetails()}
      </Fragment>
    );
  };
  const abloesung = () => {
    if (vertragstatus === "1" || vertragstatus === "2") {
      return (
        <Fragment>
          <Grid item xs={12}>
            <JaNeinSelect
              label={t("Soll der Arbeitnehmer eine zuvor entsandte Person ablösen?")}
              value={abloesen}
              onChange={(event) => setAbloesen(event.target.value)}
              error={abloesen === ""}
            />
          </Grid>
          {abloesen === "J" && (
            <Fragment>
              <Grid item xs={12}>
                <A1TextField
                  select
                  label={t("Geschlecht")}
                  value={ablgeschlecht}
                  onChange={(event) => setAblGeschlecht(event.target.value)}
                  error={ablgeschlecht === ""}
                >
                  <A1MenuItem value="M">{t("männlich")}</A1MenuItem>
                  <A1MenuItem value="W">{t("weiblich")}</A1MenuItem>
                  <A1MenuItem value="D">{t("divers")}</A1MenuItem>
                  <A1MenuItem value="X">{t("unbestimmt")}</A1MenuItem>
                </A1TextField>
              </Grid>
              <Grid item xs={12}>
                <A1TextField
                  label={t("Vorname")}
                  value={ablvorname}
                  onChange={(event) => setAblVorname(event.target.value)}
                  inputProps={{
                    maxLength: 30,
                  }}
                  error={ablvorname === "" || ablvornamefehler !== ""}
                />
              </Grid>
              <Grid item xs={12}>
                <A1TextField
                  label={t("Nachname")}
                  value={ablnachname}
                  onChange={(event) => setAblNachname(event.target.value)}
                  inputProps={{
                    maxLength: 30,
                  }}
                  error={ablnachname === "" || ablnamefehler !== ""}
                />
              </Grid>
              <Grid item xs={12}>
                <A1DateTextField
                  label={t("Geburtsdatum")}
                  value={ablgeburtsdatum}
                  onChange={(value) => {
                    setAblGeburtsdatum(value);
                  }}
                  error={(ablgeburtsdatum === "") !== ""}
                />
              </Grid>
              {ablgeburtsdatum !== "" && (
                <Fragment>
                  <Grid item xs={12}>
                    <A1TextField
                      select
                      label={t("Grund für die Ablösung der Person")}
                      value={ablgrund}
                      onChange={(event) => setAblGrund(event.target.value)}
                      error={ablgrund === ""}
                    >
                      <A1MenuItem key="1" value="1">
                        {t("Erkrankung der zuvor entsandten Person")}
                      </A1MenuItem>
                      <A1MenuItem key="2" value="2">
                        {t("Kündigung der zuvor entsandten Person")}
                      </A1MenuItem>
                      <A1MenuItem key="3" value="3">
                        {t("betriebsbedingter Personenwechsel")}
                      </A1MenuItem>
                    </A1TextField>
                  </Grid>
                  {ablgrund !== "" && (
                    <Fragment>
                      <Grid item xs={12}>
                        <A1DateTextField
                          label={t("Geplanter Beginn des Auslandeinsatzes der abzulösenden Person")}
                          value={ablgeplantbeginn}
                          onChange={(value) => {
                            setAblGeplantBeginn(value);
                          }}
                          error={ablgeplantbeginn === ""}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <A1DateTextField
                          label={t("Geplantes Ende des Auslandeinsatzes der abzulösenden Person")}
                          value={ablgeplantende}
                          onChange={(value) => {
                            setAblGeplantEnde(value);
                          }}
                          error={ablgeplantende === ""}
                        />
                      </Grid>
                    </Fragment>
                  )}
                  {ablgeplantende !== "" && ablgeplantbeginn && (
                    <Fragment>
                      <Grid item xs={12}>
                        <A1DateTextField
                          label={t("Tatsächliches Beginn des Auslandeinsatzes der abzulösenden Person")}
                          value={abltatsachbeginn}
                          onChange={(value) => {
                            setAblTatSachBeginn(value);
                          }}
                          error={abltatsachbeginn === ""}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <A1DateTextField
                          label={t("Tatsächliches Ende des Auslandeinsatzes der abzulösenden Person")}
                          value={abltatsachende}
                          onChange={(value) => {
                            setAblTatSachEnde(value);
                          }}
                          error={abltatsachende === ""}
                        />
                      </Grid>
                    </Fragment>
                  )}
                </Fragment>
              )}
            </Fragment>
          )}
          {abloesen !== "" && weiterebeschaft()}
        </Fragment>
      );
    }
  };
  const edit_beschaeftstellendaten = (key, value, id) => {
    var temp_daten = beschaeftstellendaten.slice();
    var temp_stelle = ausgewaehltestellen.slice();
    temp_daten[key][id] = value;
    if (id === "weitere") {
      if (value === "J") {
        if (festeauslandsstellen.length < 2) {
          temp_stelle.push("0");
          temp_daten.push({ ...festeauslandsstellen[0], weitere: "" });
        } else {
          temp_stelle.push("");
        }
      } else {
        temp_daten = temp_daten.slice(0, key + 1);
      }
    }
    setBeschaeftStellenDaten(temp_daten);
    setAusgewaehlteStellen(temp_stelle);
  };
  const setzte_stelle = (index, auswahl) => {
    var temp_stellen = ausgewaehltestellen.slice();
    var temp_stellen_daten = beschaeftstellendaten.slice();
    temp_stellen[index] = auswahl;
    temp_stellen_daten[index] = festeauslandsstellen[auswahl];
    setAusgewaehlteStellen(temp_stellen);
    setBeschaeftStellenDaten(temp_stellen_daten);
  };

  const stellenFrage = useMemo(
    () =>
      ausgewaehltestellen?.map((element, index) => {
        if (beschaeftstellendaten[index] !== undefined) {
          return (
            <Fragment>
              <Grid item xs={12}>
                <A1TextField
                  select
                  label={t("Welche Beschäftigungsstelle?")}
                  value={element}
                  onChange={(event) => setzte_stelle(index, event.target.value)}
                  error={element === ""}
                >
                  {festeauslandsstellen?.map((werte, zaehler) => {
                    return <A1MenuItem value={zaehler}>{werte.auswahlbez}</A1MenuItem>;
                  })}
                </A1TextField>
              </Grid>
              {element !== "" && (
                <Fragment>
                  <Grid item xs={12}>
                    <A1TextField
                      label={"Name der " + Number(index + 1) + ". Beschäftigungsstelle"}
                      value={beschaeftstellendaten[index].name}
                      onChange={(event) => edit_beschaeftstellendaten(index, event.target.value, "name")}
                      error={beschaeftstellendaten[index].name === ""}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <A1TextField
                      label={t("Strasse")}
                      value={beschaeftstellendaten[index].strasse}
                      onChange={(event) => edit_beschaeftstellendaten(index, event.target.value, "strasse")}
                      error={beschaeftstellendaten[index].strasse === ""}
                      inputProps={{
                        maxLength: 33,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <A1TextField
                      label={t("Hausnummer")}
                      value={beschaeftstellendaten[index].hnr}
                      onChange={(event) => edit_beschaeftstellendaten(index, event.target.value, "hnr")}
                      error={beschaeftstellendaten[index].hnr === ""}
                      inputProps={{
                        maxLength: 9,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <A1TextField
                      label={t("Adresszusatz")}
                      value={beschaeftstellendaten[index].zusatz}
                      onChange={(event) => edit_beschaeftstellendaten(index, event.target.value, "zusatz")}
                      inputProps={{
                        maxLength: 40,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <A1TextField
                      label={t("Postleitzahl")}
                      value={beschaeftstellendaten[index].plz}
                      onChange={(event) => edit_beschaeftstellendaten(index, event.target.value, "plz")}
                      inputProps={{
                        maxLength: 10,
                      }}
                      error={beschaeftstellendaten[index].plz === ""}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <A1TextField
                      label={t("Ort")}
                      value={beschaeftstellendaten[index].ort}
                      onChange={(event) => edit_beschaeftstellendaten(index, event.target.value, "ort")}
                      inputProps={{
                        maxLength: 34,
                      }}
                      error={beschaeftstellendaten[index].ort === ""}
                    />
                  </Grid>
                  {index !== 10 && (
                    <Grid item xs={12}>
                      <JaNeinSelect
                        label={t("Weitere")}
                        value={beschaeftstellendaten[index].weitere}
                        onChange={(event) => edit_beschaeftstellendaten(index, event.target.value, "weitere")}
                        error={beschaeftstellendaten[index].weitere === ""}
                      />
                    </Grid>
                  )}
                </Fragment>
              )}
            </Fragment>
          );
        } else {
          return <></>;
        }
      }),
    [ausgewaehltestellen, festeauslandsstellen, beschaeftstellendaten]
  );

  const schiffDaten = () => {
    return (
      <Fragment>
        <Grid item xs={12}>
          <A1TextField
            label={t("Name des Schiffes")}
            value={schiffname}
            onChange={(event) => setSchiffName(event.target.value)}
            error={schiffname === ""}
          />
        </Grid>
        <Grid item xs={12}>
          <A1TextField
            label={t("IMO-Nummer des Schiffes (IMOXXXXXXX)")}
            value={schiffimo}
            onChange={(event) => setSchiffIMO(event.target.value)}
            error={schiffimo === ""}
          />
        </Grid>
        {schiffimo !== "" && schiffname !== "" && abloesung()}
      </Fragment>
    );
  }

  const beschaft_frage = () => {
    return (
      <Fragment>
        <Grid item xs={12}>
          <A1TextField
            select
            label={t("Ist der Arbeitnehmer, im Beschäftigungsstaat, festen Beschäftigungsstellen zugeteilt?")}
            value={beschaeftstelle}
            onChange={(event) => setBeschaeftStelle(event.target.value)}
            error={beschaeftstelle === ""}
          >
            <A1MenuItem value="N">{t("Nein")}</A1MenuItem>
            <A1MenuItem value="J">{t("feste Beschäftigungsstelle(n)")}</A1MenuItem>
            <A1MenuItem value="SCHIFF">{t("Tätigkeit auf einem Schiff")}</A1MenuItem>
          </A1TextField>
        </Grid>
        {beschaeftstelle === "J" && stellenFrage}
        {(beschaeftstelle === "N" ||
          beschaeftstellendaten[beschaeftstellendaten.length - 1].weitere === "N" ||
          beschaeftstellendaten.length === 10) &&
          abloesung()}
        {beschaeftstelle === "SCHIFF" && schiffDaten()}
      </Fragment>
    );
  };
  const firmendaten = () => {
    return (
      <Fragment>
        <Grid item xs={12}>
          <A1TextField
            select
            label={"Ist die Anschrift des Arbeitnehmers im Beschäftigungsstaat bereits bekannt? (z.B. Hotel, Pension)"}
            value={anschrift}
            onChange={(event) => setAnschrift(event.target.value)}
            error={anschrift === ""}
          >
            <A1MenuItem key="J" value="J">
              {t("Ja die Anschrift im Beschäftigungsstaat ist bereits bekannt")}
            </A1MenuItem>
            <A1MenuItem key="N" value="N">
              {t("Nein die Anschrift im Beschäftigungsstaat ist nicht bekannt")}
            </A1MenuItem>
          </A1TextField>
        </Grid>
        {anschrift === "J" && (
          <Fragment>
            <Grid item xs={12}>
              <A1TextField
                label={t("Strasse")}
                value={strasse}
                onChange={(event) => setStrasse(event.target.value)}
                inputProps={{
                  maxLength: 33,
                }}
                error={strasse === "" || strfehler !== ""}
              />
            </Grid>
            <Grid item xs={12}>
              <A1TextField
                label={t("Hausnummer")}
                value={hnr}
                onChange={(event) => setHnr(event.target.value)}
                inputProps={{
                  maxLength: 9,
                }}
                error={hnr === "" || hnrfehler !== ""}
              />
            </Grid>
            <Grid item xs={12}>
              <A1TextField
                label={t("Adresszusatz")}
                value={zusatz}
                onChange={(event) => setZusatz(event.target.value)}
                inputProps={{
                  maxLength: 40,
                }}
                error={zusatz === ""}
              />
            </Grid>
            <Grid item xs={12}>
              <A1TextField
                label={t("Postleitzahl")}
                value={plz}
                onChange={(event) => setPlz(event.target.value)}
                inputProps={{
                  maxLength: 10,
                }}
                error={plz === "" || plzfehler !== ""}
              />
            </Grid>
            <Grid item xs={12}>
              <A1TextField
                label={t("Ort")}
                value={ort}
                onChange={(event) => setOrt(event.target.value)}
                inputProps={{
                  maxLength: 34,
                }}
                error={ort === "" || ortfehler !== ""}
              />
            </Grid>
          </Fragment>
        )}
        {anschrift !== "" && beschaft_frage()}
      </Fragment>
    );
  };
  const pruefeUeberlassen = () => {
    if (ueberlassen !== "") {
      return (
        <Fragment>
          {ueberlassen === "J" && (
            <Grid item xs={12}>
              <Box p={1}>
                <Typography variant="h6" align="left" color="error">
                  {t(
                    "Bei einer Überlassung des Arbeitnehmers an ein anderes Unternehmen, ist es wahrscheinlich, dass der Antrag abgelehnt wird!"
                  )}
                </Typography>
              </Box>
            </Grid>
          )}
          {firmendaten()}
        </Fragment>
      );
    }
  };
  const pruefeVertragsStatus = () => {
    if (taetigkeit === "") {
      return null;
    }
    if (vertragstatus === "1" || vertragstatus === "2") {
      return (
        <Fragment>
          <Grid item xs={12}>
            <JaNeinSelect
              label={t("Wird der Arbeitnehmer einem anderen Unternehmen überlassen?")}
              value={ueberlassen}
              onChange={(event) => setUeberlassen(event.target.value)}
              error={ueberlassen === ""}
            />
          </Grid>
          {pruefeUeberlassen()}
        </Fragment>
      );
    }
    if (vertragstatus === "3" || vertragstatus === "4" || vertragstatus === "5") {
      return (
        <Fragment>
          <Grid item xs={12}>
            <Box p={1}>
              <Typography variant="h6" align="left">
                {t(
                  "Für Entsendungen, bei denen ein, ggf. zusätzlicher, lokaler Vertrag mit dem Arbeitgeber im Ausland besteht, muss eine Ausnahmevereinbarung beantragt werden."
                )}
              </Typography>
              <Typography variant="h6" align="left" color="error">
                {t("Bitte wenden Sie sich an ihre Personalabteilung.")}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box p={1}>
              <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                {t("Zurück")}
              </Button>
            </Box>
          </Grid>
        </Fragment>
      );
    }
  };
  const setzeLand = (newValue) => {
    newValue !== null ? setLand(newValue.key) : setLand();
  };
  const setzeTaetigkeit = (newValue) => {
    newValue !== null ? setTaetigkeit(newValue.key) : setTaetigkeit("");
  };
  const pruefe_taet = (eingabe) => {
    if (eingabe.length === 5) {
      setIssending(true);
      setTaetigkeit(eingabe);
      const payload = {
        mandant: client,
        program: "LA1MAP",
        start: admin ? "" : "INIT_AN",
        statement: "HOLE_BESCHAEFT",
        taet: eingabe,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, taetcb, errorCb);
    }
  };
  const taetcb = (response) => {
    setIssending(false);
    if (response.status === 200) {
      if (response.data.taet) {
        setTaetigkeiten(response.data.taet);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const selectedTaetigkeit = useMemo(
    () => taetigkeiten.find((element) => element.key === taetigkeit)?.key,
    [taetigkeiten, taetigkeit]
  );

  const selectedLand = useMemo(() => laender.find((element) => element.key === land), [laender, land]);

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <Page>
      <Layout fullWidth>
        {!antragid ? (
          <Typography variant="h6">{t("Neue A1-Bescheinigung erstellen")}</Typography>
        ) : (
          <Typography variant="h6">{t("A1-Bescheinigung bearbeiten")}</Typography>
        )}
      </Layout>
      <Layout>
        <Box p={1}>
          <Grid container gap={2}>
            {admin && !mitarbeiter && !antragid && (
              <Fragment>
                <Grid item xs={12}>
                  <Typography align="left">{t("Für welchen Mitarbeiter")}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Box p={1}>
                    <Mitarbeiterauswahl
                      programm={"LA1MAP"}
                      client={client}
                      onChange={(value) => setMitarbeiter(value)}
                    />
                  </Box>
                </Grid>
              </Fragment>
            )}
            {(mitarbeiter || !admin || antragid) && (
              <Fragment>
                {admin && (
                  <Fragment>
                    <Grid item xs={12}>
                      <A1TextField
                        label={t("Mitarbeiter")}
                        value={anzeigema}
                        disabled
                        error={anzeigema === ""}
                      ></A1TextField>
                    </Grid>
                    {!antragid && (
                      <Grid item xs={12}>
                        <Box p={1}>
                          <Button onClick={() => setMitarbeiter("")} color="primary" fullWidth>
                            {t("Mitarbeiter wechseln")}
                          </Button>
                        </Box>
                      </Grid>
                    )}
                  </Fragment>
                )}
                <Grid item xs={12}>
                  <Autocomplete
                    fullWidth
                    onChange={(event, newValue) => {
                      setzeLand(newValue);
                    }}
                    value={selectedLand}
                    options={laender}
                    getOptionLabel={(option) => option.bezeichnung}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("In welches Land wird der Arbeitnehmer entsendet?")}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={land === ""}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              {land !== "" ? (
                                <CheckCircleOutlineIcon
                                  style={{
                                    color: "rgba(" + farbe_fertig + " ,0.8)",
                                  }}
                                />
                              ) : (
                                <ErrorOutlineIcon
                                  style={{
                                    color: "rgba(" + farbe_error + " ,0.8)",
                                  }}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
                {land && (
                  <Fragment>
                    <A1DateTextField
                      label={t("Wann soll der Auslandsaufenthalt des Arbeitnehmers beginnen?")}
                      value={vonzeitraum}
                      onChange={(value) => {
                        setVonZeitraum(value);
                        setZeitraumFehler("");
                      }}
                      error={vonzeitraum === "" || zeitraumfehler !== ""}
                    />
                    <A1DateTextField
                      fullWidth
                      label={t("Wann wird der Auslandsaufenthalt des Arbeitnehmers vorraussichtlich enden?")}
                      value={biszeitraum}
                      onChange={(value) => {
                        setBisZeitraum(value);
                        setZeitraumFehler("");
                      }}
                      error={biszeitraum === "" || zeitraumfehler !== ""}
                    />
                    <Autocomplete
                      fullWidth
                      noOptionsText={"Keine Tätigkeit gefunden. "}
                      onChange={(event, newValue) => {
                        setzeTaetigkeit(newValue);
                        setTaetFehler("");
                      }}
                      defaultValue={selectedTaetigkeit}
                      options={taetigkeiten}
                      onInputChange={(event, newValue) => {
                        pruefe_taet(newValue);
                      }}
                      loading={issending}
                      getOptionLabel={(option) => option.bezeichnung}
                      renderInput={(params) => (
                        <A1TextField
                          {...params}
                          label={t("Welche Tätigkeit wird der Arbeitnehmer im Ausland ausführen?")}
                          error={taetigkeit === "" || taetfehler !== ""}
                        />
                      )}
                    />
                    {taetigkeit && (
                      <Fragment>
                        <Grid item xs={12}>
                          <A1TextField
                            select
                            label={t("Bleibt der Arbeitsvertrag des Arbeitnehmers in der jetzigen Form bestehen?")}
                            value={vertragstatus}
                            onChange={(event) => {
                              setVertragStatus(event.target.value);
                            }}
                            error={vertragstatus === ""}
                          >
                            <A1MenuItem key="1" value="1">
                              {t("Ja, der Arbeitsvertrag besteht unverändert weiter")}
                            </A1MenuItem>
                            <A1MenuItem key="2" value="2">
                              {t("Ja, der Arbeitsvertrag besteht weiter und wurde um eine Entsendung ergänzt")}
                            </A1MenuItem>
                            <A1MenuItem key="3" value="3">
                              {t(
                                "Nein, der Arbeitsvertrag mit dem Arbeitgeber in Deutschland ruht, es wurde eine Vereinbarung/Vertrag mit dem Arbeitgeber im Ausland geschlossen"
                              )}
                            </A1MenuItem>
                            <A1MenuItem key="4" value="4">
                              {t(
                                "Nein, es bestehen aktive Arbeitsverträge mit dem Arbeitgeber in Deutschland und im Ausland"
                              )}
                            </A1MenuItem>
                            <A1MenuItem key="5" value="5">
                              {t("Es besteht kein Arbeitsvertrag mit dem Arbeitgeber in Deutschland")}
                            </A1MenuItem>
                          </A1TextField>
                        </Grid>
                        {pruefeVertragsStatus()}
                      </Fragment>
                    )}
                  </Fragment>
                )}
              </Fragment>
            )}
          </Grid>
        </Box>
      </Layout>
      {ladedaten && <FullPageSpinner />}
      {isProcessing && <FullPageSpinner />}
    </Page>
  );
}

const A1TextField = ({
  value,
  error = false,
  children,
  onChange,
  select = false,
  disabled = false,
  label,
  ...props
}) => {
  return (
    <>
      <Typography variant="subtitle1" color={disabled ? "textSecondary" : ""}>
        {label}
      </Typography>
      <TextField
        select={select}
        disabled={disabled}
        variant="outlined"
        // label={label}
        // helperText={label}
        value={value}
        onChange={onChange}
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
        error={error}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              {!error ? (
                <CheckCircleOutlineIcon
                  style={{
                    color: "rgba(" + farbe_fertig + " ,0.8)",
                  }}
                />
              ) : (
                <ErrorOutlineIcon
                  style={{
                    color: "rgba(" + farbe_error + " ,0.8)",
                  }}
                />
              )}
            </InputAdornment>
          ),
        }}
        {...props}
      >
        {children}
      </TextField>
    </>
  );
};

const JaNeinSelect = ({ value, error = false, onChange, disabled = false, label }) => {
  const { t } = useTranslation();
  return (
    <A1TextField select label={label} value={value} onChange={onChange} error={error} disabled={disabled}>
      <A1MenuItem key="J" value="J">
        {t("Ja")}
      </A1MenuItem>
      <A1MenuItem key="N" value="N">
        {t("Nein")}
      </A1MenuItem>
    </A1TextField>
  );
};

const A1DateTextField = ({ value, error = false, children, onChange, disabled = false, label, ...props }) => {

  const handleDateChange = (e) => {
    onChange(e.format('YYYY-MM-DD'));
    
  }
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
    <DatePicker
      disabled={disabled}
      variant="outlined"
      label={label}
      value={moment(value)}
      onChange={handleDateChange}
      slotProps={{
        textField: {
          error: error,
          fullWidth: true,
          InputLabelProps: {
            shrink: true,
          },
          InputProps:{
            startAdornment: (
              <InputAdornment position="start">
                {!error ? (
                  <CheckCircleOutlineIcon style={{ color: "rgba(" + farbe_fertig + " ,0.8)" }} />
                ) : (
                  <ErrorOutlineIcon style={{ color: "rgba(" + farbe_error + " ,0.8)" }} />
                )}
              </InputAdornment>
            ),
          }
        }
      }}
      {...props}
    />
    </LocalizationProvider>
  );
};

const A1MenuItem = ({ children, value, ...props }) => {
  return (
    <MenuItem
      style={{
        wordBreak: "break-word",
        whiteSpace: "normal",
      }}
      value={value}
      {...props}
    >
      {children}
    </MenuItem>
  );
};

export default A1CertificateNew;
